import LawFirmWebsite from './components/LawFirmWebsite';
import './App.css';

function App() {
  return (
    <LawFirmWebsite />
  );
}

export default App;
